const searchCard = ({ linkURL, title, excerpt }) => `
    <div class="search-card">
    <a class="search-card__main-link" href="${linkURL}"></a>
        <div class="search-card__body">
            <h3 class="h5 search-card__title">${title}</h3>
            <div class="search-card__excerpt">${excerpt}
            </div>
        </div>
    </div>
`;

export { searchCard };
